import type { DayFacts } from '../core/day-facts';
import type { CallExtraction } from '../core/extraction';
import type { Transcript } from '../core/transcript';

/**
 * The sample conversation shown on "watch an example" and to visitors the voice provider does
 * not serve (RU/BY). The card is computed by the real pipeline from SAMPLE_EXTRACTION.
 */
export const SAMPLE_TRANSCRIPT: Transcript = [
  {
    speaker: 'vera',
    text: 'Здравствуйте! Это Вера, голосовой помощник. Звоню узнать, как у вас дела, Галина Петровна. Удобно пару минут поговорить?',
  },
  { speaker: 'parent', text: 'Здравствуй, Верочка. Удобно, конечно.' },
  { speaker: 'vera', text: 'Как вы себя сегодня чувствуете? Как спалось?' },
  { speaker: 'parent', text: 'Спала неплохо. Только колено опять ноет, на погоду, наверное.' },
  { speaker: 'vera', text: 'Сочувствую. Я передам вашим родным. А утренние таблетки уже приняли?' },
  { speaker: 'parent', text: 'Приняла, сразу после завтрака.' },
  { speaker: 'vera', text: 'Хорошо. Какие планы на сегодня?' },
  { speaker: 'parent', text: 'Схожу за хлебом, а вечером соседка Нина зайдёт.' },
  { speaker: 'vera', text: 'Звучит хорошо. Что вас сегодня порадовало?' },
  { speaker: 'parent', text: 'Внук вчера фотографии прислал, весь вечер смотрела.' },
  { speaker: 'vera', text: 'Как приятно. Завтра позвоню в это же время. Берегите себя!' },
];

/** What prompts/summary.md is expected to return for SAMPLE_TRANSCRIPT. */
export const SAMPLE_EXTRACTION: CallExtraction = {
  mood: 'good',
  sleep: 'ok',
  meds_taken: true,
  ate: true,
  went_out_or_plans: 'за хлебом, вечером зайдёт соседка',
  complaints: [{ what: 'колено', severity: 'mild' }],
  mentions: [],
  quote: 'Внук вчера фотографии прислал, весь вечер смотрела.',
  summary_ru:
    'Мама в хорошем настроении, выспалась, таблетки приняла. Снова жаловалась на колено. Вечером зайдёт соседка Нина.',
};

/** Earlier days, newest first: the knee was already mentioned three days ago. */
export const SAMPLE_HISTORY: DayFacts[] = [
  { mood: 'good', medsTaken: true, complaints: [], redFlags: [], attentionFlags: [] },
  { mood: 'neutral', medsTaken: true, complaints: [], redFlags: [], attentionFlags: [] },
  {
    mood: 'good',
    medsTaken: true,
    complaints: [{ what: 'колено', severity: 'mild' }],
    redFlags: [],
    attentionFlags: [],
  },
];
